import React from 'react';

export const useThrottleFunction = (cooldownS = 5) => {
  const [cooldown, setCooldown] = React.useState(0);
  const intervalRef = React.useRef<NodeJS.Timeout | null>(null);

  const cooldownMs = cooldownS * 1000;

  const trigger = React.useCallback(
    (fn: () => void) => {
      if (cooldown > 0) return;

      fn();

      setCooldown(cooldownMs);

      intervalRef.current = setInterval(() => {
        setCooldown(prev => {
          if (prev <= 1000 && intervalRef?.current) {
            clearInterval(intervalRef.current);
            return 0;
          }

          return prev - 1000;
        });
      }, 1000);
    },
    [cooldown, cooldownMs],
  );

  React.useEffect(() => {
    return () => {
      if (!intervalRef.current) return;

      clearInterval(intervalRef.current);
    };
  }, []);

  return {
    trigger,
    cooldown,
  };
};
